import { ItemGallery } from 'features/itemGallery/ItemGallery';

export const ItemGalleryPage = (): JSX.Element => (
    <div style={{ width: '90vw' }}>
        {' '}
        <ItemGallery />{' '}
    </div>
);
